import { ApiClient, ApiClientConfig } from "../api-client";
import { ApiClientError } from "../errors";
import schemaValidators from "./schema-validators";

export default class PaymentClient extends ApiClient<typeof schemaValidators> {
	constructor(config: ApiClientConfig) {
		super(config, {});
	}

	initiatePayment = async ({ assessmentId }: { assessmentId: number }) => {
		try {
			const res = await super.fetch(new URL(`/api/verity/payment`, this.config.verityOrigin), {
				method: "POST",
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					assessmentId,
				}),
			});
			if (res.ok) {
				return (await res.json()) as {
					clientSecret?: string;
					paid?: boolean;
				};
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};

	checkPaymentStatus = async ({ sessionId, assessmentId }: { sessionId: string; assessmentId: number }) => {
		try {
			const res = await super.fetch(
				new URL(
					`/api/verity/payment/complete?stripeSessionId=${sessionId}&assessmentId=${assessmentId}`,
					this.config.verityOrigin,
				),
				{
					method: "GET",
					credentials: "include",
				},
			);
			if (res.ok) {
				return (await res.json()) as { complete: boolean };
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};

	getEnabled = async () => {
		try {
			const res = await super.fetch(new URL(`/api/verity/payment/enabled`, this.config.verityOrigin), {
				method: "GET",
				credentials: "include",
			});
			if (res.ok) {
				return (await res.json()) as { enabled: boolean };
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};
}
